<template>
  <div class="formNewUser">  

      <h2>dados pessoais</h2>
        <v-form
          ref="form"
          v-model="valid"
        >
      <div class="innerContainer">
          <v-text-field color="#E46C0A " :rules="rules.name" type="text" placeholder="nome" v-model="name" name="Name"></v-text-field>
          <v-text-field color="#E46C0A " :rules="rules.lastName"  type="text" placeholder="sobrenome" v-model="lastName" name="LastName"></v-text-field>
          <v-text-field color="#E46C0A " :rules="rules.cpf" v-mask="['###.###.###-##']"  placeholder="cpf" name="cpf" v-model="cpf" ></v-text-field>
          <v-text-field v-mask="['##/##/####']" :rules="rules.birthday" name="BirthDay" type="text" v-model="birthday" class="BirthDay" color="#E46C0A " placeholder="data de nascimento" ></v-text-field>
          <div class="div-checkbox" v-if="betWeen12and18">
            <input type="checkbox" v-model="AuthResponsible" name="AuthResponsible" />
            <div class="styled-checkbox" @click="AuthResponsible = !AuthResponsible"><Check v-if="AuthResponsible"/></div>
            <span >Tenho a autorização dos meus responsáveis legais para a realização deste cadastro</span>
          </div>
          <v-text-field color="#E46C0A " :rules="rules.phone" v-mask="['(##) ####-####','(##) #####-####']" type="tel" name="Phone" placeholder="telefone" v-model="phone"></v-text-field>    
      </div>
      <h2>dados cadastrais</h2>
      <div class="innerContainer">
          <v-text-field class="lowercase" color="#E46C0A " :rules="rules.email" name="email" placeholder="e-mail" v-model="email" ></v-text-field>
          <v-text-field class="lowercase" @paste="e=>e.preventDefault()" color="#E46C0A " :rules="rules.confirmEmail" placeholder="confirmação de e-mail" v-model="confirmEmail" ></v-text-field>     
          <v-text-field v-if="!googleID && !facebookID" color="#E46C0A " :rules="rules.password" placeholder="senha" name="password"  :type="show1 ? 'text' : 'password'" v-model="password" >
            <template v-slot:append>
                <img v-if="!show1" width="24" src="../assets/img/olhovazado.svg" @click="show1 = !show1" height="24" style="cursor:pointer"/>
                <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show1 = !show1" height="24" style="cursor:pointer"/>
              </template>
          </v-text-field>
          <v-text-field color="#E46C0A " v-if="!googleID && !facebookID" :rules="rules.confirmPassword" :type="show2 ? 'text' : 'password'" placeholder="confirmação de senha" v-model="confirmPassword" >
          <template v-slot:append>
                              <img v-if="!show2" width="24" src="../assets/img/olhovazado.svg" @click="show2 = !show2" height="24" style="cursor:pointer"/>
                <img v-else width="24" src="../assets/img/olhovazado-laranja.svg" @click="show2 = !show2" height="24" style="cursor:pointer"/>
              </template>

          </v-text-field>
          <v-text-field color="#E46C0A " name="googleID" type="hidden" v-model="googleID" style="display:none"></v-text-field>
        <v-text-field color="#E46C0A " name="facebookID" type="hidden" v-model="facebookID" style="display:none"></v-text-field>
        <div v-if="!this.facebookID && !this.googleID">
          <strong>Receber o código de verificação de conta por: </strong><br>
          <div style="display: flex; padding: 10px 0;">
            <div style="padding: 5px 10px 5px 0; display: flex; align-items: center;">
              <input type="checkbox" v-model="tipoVerificacao" value="e-mail" name="tipoVerificacao" />
              <div class="styled-checkbox" @click="tipoVerificacao = 'e-mail'"><Check v-if="tipoVerificacao == 'e-mail'"/></div>
              <span style="padding-left: 10px;">E-mail</span>
            </div>
            <!--<div style="padding: 5px 10px; display: flex; align-items: center;">
              <input type="checkbox" v-model="tipoVerificacao" value="sms" name="tipoVerificacao" />
              <div class="styled-checkbox" @click="tipoVerificacao = 'sms'"><Check v-if="tipoVerificacao == 'sms'"/></div>
              <span style="padding-left: 10px;">SMS</span>
            </div>-->
          </div>
          <span v-if="!tipoVerificacao" class="formError token" style="display:none">Selecione uma forma de receber o código de verificação.</span>
        </div>
      </div>
      </v-form>
      <MeuCartaoGiro />
      <p v-if='cardblock' class="valid-false">{{popupMessages.cardBlock.validation}}</p>
      <div class="div-checkbox">
        <input type="checkbox" v-model="infoPromo" name="infoPromo" />
        <div class="styled-checkbox" @click="infoPromo = !infoPromo"><Check v-if="infoPromo"/></div>
        <span >Quero ser informado de promoções e novidades do MetrôRio por e-mail</span>
      </div>
      
      <div class="div-checkbox">
        <input type="checkbox" v-model="infoTerms" name="infoTerms" />
        <div class="styled-checkbox" @click="infoTerms = !infoTerms"><Check v-if="infoTerms"/></div>
        
        <span >Declaro que aceito os <a @click="openTerms">termos e condições</a> e as <a @click="openPrivacy">declaração de privacidade</a> do Giro MetrôRio.</span>
        <span v-if="!infoTerms || (this.betWeen12and18 && !this.AuthResponsible)" class="formError inf" style="display:none">Para prosseguir é necessário aceitar os termos e a declaração de privacidade</span>
      </div>
         <v-app>
   <v-dialog v-model="dialog.open" max-width="600px">
      <v-card>
        <v-card-title>
          <span >{{dialog.title}}</span>
        </v-card-title>
        <v-card-text>
          <p v-html="dialog.message">{{dialog.message}}</p>
          <p v-if="dialog.cardMessage">{{dialog.cardMessage}}</p>
           <a @click="() =>{dialog.open = false; !dialog.action && $emit('returnLogin');}" class="btn block">fechar</a>
        </v-card-text>
      </v-card>
    </v-dialog>
    </v-app>
      <a class="btn block"  v-bind:class="disabled" appEvent="true" appEventCategory="registro" appEventLabel="cadastrar" @click="submit()" >continuar</a>
  </div>
</template>

<script>

import {mask} from 'vue-the-mask'
import {VTextField,VDialog,VCard,VCardTitle,VCardText,VApp,VForm} from 'vuetify/lib'
import {popupMessages,isUnderYearsOld,resolvePromise,validaCpf,arrayOptionsUF,regexEmail,testaSenha,buscaCep,emitToParent,returnPopupObject,testDate,formatDateToSend,saveToken} from '../helpers/helpers.js'
import MeuCartaoGiro from '@/components/MeuCartaoGiro.vue'
import Check from '@/components/svg/Check.vue'
import {save} from '../services/user.service'
import {save as saveGiro} from '../services/girocard.service'
import { login } from '../services/login.service'

export default {
  name: 'FormNewUser',
  data(){
    return{
      popupMessages,
      arrayOptionsUF:arrayOptionsUF,
      valid:false,
      dialog:{
        open:false,
        message:null,
        title:null,
        cardMessage:null,
        action:null
      },
      blockSubmit:false,
      confirmEmail:null,
      cpf:null,
      tipoVerificacao:null,
      password:null,
      confirmPassword:null,
      infoPromo:true,
      infoTerms:false,
      AuthResponsible: false,
      phone:null,
      birthday:null,
      city:null,
      uf:null,
      show1:false,
      show2:false,
      rules:{
        name:[ () => !!this.name || 'Este campo é obrigatório'],
        lastName:[()=> !!this.lastName || 'Este campo é obrigatório'],
        cpf:[()=> !!this.cpf || 'Este campo é obrigatório', 
             () => validaCpf(this.cpf) || 'Este CPF é inválido' ],
        birthday:[
          ()=> ()=> testDate(this.birthday) || 'A data deve ser digitada no formato: dd/mm/aaaa',
          ()=> !isUnderYearsOld(this.birthday, 16) || 'Não é possivel criar um cadastro com menos de 16 anos'
        ],
        phone:[()=> !!this.phone || 'Este campo é obrigatório'],
        email:[()=> !!this.email || 'Este campo é obrigatório', 
               () => regexEmail.test(this.email && this.email.toLowerCase()) || 'E-mail inválido' ],
        confirmEmail:[()=> !!this.confirmEmail || 'Este campo é obrigatório' , 
                      () => (this.confirmEmail && this.confirmEmail.toLowerCase()) === (this.email && this.email.toLowerCase()) || 'O valor não confere com o campo e-mail' ],
        password:[()=> !!this.password ||'Este campo é obrigatório', 
                  () => testaSenha(this.password) || 'A senha deve ter no mínimo 8 caracteres, números e uma letra maiúscula'],
        confirmPassword:[()=> !!this.confirmPassword || 'Este campo é obrigatório', 
                          () => (this.confirmPassword === this.password) || 'O valor não confere com o campo senha']
      }
    }
  },
  props:{
    name:{
      type:String
    },
    lastName:{
      type:String
    },
    googleID:{
      type:String
    },
    facebookID:{
      type:String
    },
    email:{
      type:String
    },
    privacy:{
      type:Object
    },
    terms:{
      type:Object
    }
  },
  directives:{
    mask
  },
  computed:{
    disabled: function(){
      return this.blockSubmit ? 'disabled' : 'enabled'
    },
    betWeen12and18: function() {
      return isUnderYearsOld(this.birthday, 18) && !isUnderYearsOld(this.birthday, 16);
    }
  },
  methods:{
    validaCpf,
    isUnderYearsOld,
    openTerms(){
      this.dialog.title = "Termos e Condições"
      this.dialog.message = this.terms.text
      this.dialog.action = "terms"
      this.dialog.open = true
    },
    openPrivacy(){
      this.dialog.title = "Declaração de Privacidade"
      this.dialog.action = 'privacy'
      this.dialog.message = this.privacy.text
      this.dialog.open = true
    },
    setEndereco(endereco){
      if(endereco.erro) return 
      this.address = endereco.logradouro
      this.city = endereco.localidade
      this.uf = endereco.uf

    },
    descobreEndereco({target}){
      const cep = target.value.replace(/\D+/g, '')
      resolvePromise(buscaCep(cep),this.setEndereco,console.log,this)
    },
   setFormData:formData => ({name,value,checked}) =>{ 
      //if(name === "BirthDay") return
      if(!name) return;
      if(name === "BirthDay") value = formatDateToSend(value)
      if(value == undefined) value = "";
      if(name === "email") value = value.toLowerCase()
      if(name !== 'tipoVerificacao') {
        formData.set(name,value === "on" ? checked : value)
      }
    },
    setMessagePopup(message,title="Erro"){
      this.dialog.message = message
      this.dialog.title = title
      if(title === "Erro") this.dialog.action = "form"
      else this.dialog.action = null      
      this.dialog.open = true
    },
    saveGiroCard(arrayGiro,id){
        const card = new FormData()
        card.append("CardNumber",arrayGiro[0])
        card.append("UserId",id)
        card.append("Active", true)
        resolvePromise(
          saveGiro(card),
          ()=>{emitToParent("openPopup",this,returnPopupObject("ok","sNew","sGiroCard")); this.$emit('returnLogin')},
          ()=>{emitToParent("openPopup",this,returnPopupObject("att","sNew","eGiroCard")); this.$emit('returnLogin')},this
        )
        this.$refs.form.reset()
    },
    sucessNewUser(){
     
      if(this.facebookID){
         resolvePromise(login({user:null,password:this.facebookID,grantType:"facebook",activationCode:null}),saveToken(this),console.log,this)
      } else if(this.googleID){    
        resolvePromise(login({user:null,password:this.googleID,grantType:"google",activationCode:null}),saveToken(this),console.log,this)
          
      }
      else{ 
        emitToParent("openPopup",this, returnPopupObject("okExclamacao","sNewEmailSms"))
        this.$emit('returnLogin')
      }

    },
    submit(){ 
      if(!this.infoTerms || (this.betWeen12and18 && !this.AuthResponsible)) document.querySelector('.formError.inf').style.display = "block"

      if(this.betWeen12and18 && !this.AuthResponsible) {
        return;
      }
      const user = new FormData();
      this.cardblock=false;
      this.message = "Erro na chamada"
      Array.from(document.querySelectorAll('.formNewUser input')).forEach(this.setFormData(user))
      let arrayGiro =  Array.from(document.querySelectorAll('.meuCartaoGiro input')).map(({value})=> value).filter(v=>v)
      if((new Set(arrayGiro)).size !== arrayGiro.length) this.setFormData(user)({name:"giroCard",value:arrayGiro[0]})
      if(!this.googleID && !this.facebookID){
        if(!this.tipoVerificacao) {
          document.querySelector('.formError.token').style.display = "block"
          return;
        } else {
          user.set('TokenType', this.tipoVerificacao == 'sms' ? '1' : '0');
        }
      }
      for (var value of user.keys()) console.log(value, user.get(value));
      if (this.$refs.form.validate() && this.infoTerms && !this.blockSubmit){
        this.blockSubmit = true
        resolvePromise(
          save(user),
          ({data}) =>{ 
            this.blockSubmit = false
            this.sucessNewUser()
          },
          err=>{
            this.blockSubmit = false 
            if(err == 'CARD-BLACK-LIST') {
              this.cardblock = true;
            } else {
              emitToParent("openPopup",this,{title:"Erro",message:err,dialog:true}),this
            }
          }
        )
      }
    }
  },
  created(){
    document.querySelectorAll(".blockPaste input").forEach(item=>item.onpaste=e=>e.preventDefault())
  },
  components: {
    VForm,
      VDialog,
      VCard,
      VCardTitle,
      VCardText,
      VApp,
      VTextField,
      MeuCartaoGiro,
      Check
    }
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/formNewUser.scss";
  .valid-false { color: red; font-size:12px; margin: 0 5%; }
</style>
